import { Component, OnInit, AfterViewInit, OnDestroy, ViewChild, ElementRef } from '@angular/core';
import { Router, NavigationEnd, ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { filter } from 'rxjs/operators';
import { Subscription } from 'rxjs';
import { EventService } from './services/events/event.service';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
  standalone: false
})
export class AppComponent implements OnInit, AfterViewInit, OnDestroy {
  @ViewChild('routerOutlet', { static: false }) routerOutlet?: ElementRef;
  
  busyLoading = false;
  isReady = true;
  chatAllowed = true;
  chatRouteAllowed = true;
  isOnline = true;
  appDisabled = false;
  updateAvailable = false;
  allowFullScreen = false;
  miniChatText = '';
  showBot = false; // Control bot visibility based on route
  private aiBotMessageSubscription?: Subscription;

  constructor(
    public router: Router,
    private translate: TranslateService,
    private activatedRoute: ActivatedRoute
  ) {
    // Set default language
    this.translate.setDefaultLang('en');
    this.translate.use('en');
    
    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        // Update bot visibility based on current route
        this.updateBotVisibility(event.urlAfterRedirects);
      });
    
    // Check initial route
    this.updateBotVisibility(this.router.url);
    
    // Listen for bot messages from components
    this.aiBotMessageSubscription = EventService.aiBotMessage.subscribe((message: string) => {
      if (message && message.length > 0) {
        this.miniChatText = message;
      }
    });
  }

  ngOnInit(): Promise<void> {
    return Promise.resolve();
  }
  
  ngAfterViewInit(): void {
    // Check router outlet content periodically
    setTimeout(() => {
      this.checkRouterOutlet();
    }, 100);
    
    setTimeout(() => {
      this.checkRouterOutlet();
    }, 500);
    
    setTimeout(() => {
      this.checkRouterOutlet();
    }, 1000);
    
    setTimeout(() => {
      this.checkRouterOutlet();
    }, 2000);
  }
  
  checkRouterOutlet(): void {
    const outlet = document.getElementById('main-content');
    if (outlet) {
      // Check for ion-content or other Ionic components
      const ionContent = outlet.querySelector('ion-content');
      
      // Check for any app-welcome, app-story, etc.
      const welcomePage = outlet.querySelector('app-welcome');
      const storyPage = outlet.querySelector('app-story');
    }
  }

  updateApp(): void {
    // Handle app update - placeholder for demo
  }

  gotoFullChat(): void {
    // Navigate to full chat if needed
  }

  aiChatClicked(message?: string | null): void {
    console.log('aiChatClicked() method fired - HeyViva bot was tapped');
    // Wake up the bot if not already awake
    EventService.aiBotAwakeState.emit(true);
    
    // If a message was provided (last message from viva-chat), use it
    if (message && message.length > 0) {
      this.miniChatText = message;
    } else {
      // No last message - show generic help message
      this.translate.get('app-component.chat.how-can-i-help').subscribe((helpMessage: string) => {
        this.miniChatText = helpMessage;
      });
    }
  }

  closeMiniChat(): void {
    this.miniChatText = '';
  }

  ngOnDestroy(): void {
    // Unsubscribe from EventService.aiBotMessage to prevent memory leak
    if (this.aiBotMessageSubscription) {
      this.aiBotMessageSubscription.unsubscribe();
    }
  }

  private updateBotVisibility(url: string): void {
    // Show bot only on /home/xxxx routes
    // Hide on / (welcome), /story/:name, and other routes
    this.showBot = url.startsWith('/home');
  }
}

